import React, { useEffect, useRef } from 'react';

type Callback = () => void;

interface OutsideClickProps extends React.HTMLAttributes<HTMLDivElement> {
  callback: Callback;
  executeCallback: boolean;
  children: React.ReactElement;
}

export const OutsideClick = ({
  callback,
  executeCallback,
  children,
  ...rest
}: OutsideClickProps ) => {
  const outsideClickViewRef = useRef<HTMLDivElement>( null );

  useEffect(() => {
    const handleClickOutside = ( event: MouseEvent ) => {
      if (outsideClickViewRef.current && !outsideClickViewRef.current.contains( event.target as Node )) {
        callback();
      }
    };

    if ( executeCallback ) {
      document.addEventListener('mousedown', handleClickOutside );
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside );
    };
  }, [ callback, executeCallback ]);

  return React.cloneElement( children, { ...rest, ref: outsideClickViewRef });
};
